import React, {Component} from 'react'
import style from './style'
import {withStyles, Paper, Popper, Typography} from '@material-ui/core'
import {cardLogos} from '../../modules/payment/components/CardNumberInput/cardsHelper'
import CustomGridList from './CustomGridList'
import partition from 'lodash/partition'
import size from 'lodash/size'
import {DEBIT_CARD_IDS, OFFLINE_PAYMENT_METHODS, PAGO_MIS_CUENTAS} from '../../shared/constants'

class PaymentMethodList extends Component {

	constructor(props) {
		super(props)
		this.state = {
			helpOpened: false,
			anchorEl: null,
			arrowRef: null,
			isMobile: null
		}

		this.openHelp = this.openHelp.bind(this)
		this.closeHelp = this.closeHelp.bind(this)
		this.handleArrowRef = this.handleArrowRef.bind(this)

		this.mapCardLogosByType()
	}

	mapCardLogosByType() {
		const onlinePaymentMethods = this.props.paymentMethods.filter(paymentMethodId => !OFFLINE_PAYMENT_METHODS.includes(paymentMethodId) && paymentMethodId !== PAGO_MIS_CUENTAS)
		const cardIds = partition(onlinePaymentMethods, id => DEBIT_CARD_IDS.includes(id))
		this.debitCardLogos = cardIds[0].map(id => cardLogos[id]).filter(Boolean)
		this.creditCardLogos = cardIds[1].map(id => cardLogos[id]).filter(Boolean)
	}

	openHelp(e) {
		this.setState({
			anchorEl: e.target,
			helpOpened: true
		})
	}

	closeHelp() {
		this.setState({
			helpOpened: false
		})
	}

	handleArrowRef(node) {
		this.setState({
			arrowRef: node
		})
	}

	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this));
		this.resize();
	}

	resize() {
		this.setState({isMobile: window.innerWidth <= 480});
	}

	render() {
		const {classes} = this.props
		return (
			<div id="payment-methods-list">
				<Popper
					className={classes.popper}
					open={this.state.helpOpened}
					anchorEl={this.state.anchorEl}
					placement={this.state.isMobile ? "bottom" : "right"}
					modifiers={{
						arrow: {
							enabled: true,
							element: this.state.arrowRef
						}
					}}>
					<React.Fragment>
						<Paper className={classes.popperContent}>
							{size(this.creditCardLogos) > 0 &&
							<div id="credit-card-logos">
								<CustomGridList logos={this.creditCardLogos} title="Tarjetas de crédito"/>
							</div>}
							{size(this.debitCardLogos) > 0 &&
							<div id="debit-card-logos">
								<CustomGridList logos={this.debitCardLogos} title="Tarjetas de débito"/>
							</div>}
						</Paper>
						<img alt="" src={`${window.env.ASSETS_URL}/images/templates/arrow.png`} className={classes.arrow}
								 ref={this.handleArrowRef}/>
					</React.Fragment>
				</Popper>
				<div className={classes.row}>
					<Typography
						role="button"
						variant="subtitle1"
						type="button"
						className={classes.helpButton}
						onMouseEnter={this.openHelp}
						onMouseLeave={this.closeHelp}
						tabIndex={-1}
					>Medios de pago</Typography>
				</div>
			</div>
		)
	}
}

export default withStyles(style)(PaymentMethodList)